import { Pipe, PipeTransform } from '@angular/core';

/**
 * Formats a North American phone number (NANP) for display as `(NNN) NNN-NNNN`.
 *
 * Notes
 * - This pipe is intended for North American Numbering Plan (NANP) phone numbers.
 * - It strips all non-digit characters, and will drop a leading `1` country code when present.
 *
 * Behavior
 * - Empty/whitespace input returns an empty string.
 * - If the value does not normalize to exactly 10 digits (after stripping non-digits and an
 *   optional leading `1`), the original trimmed string is returned unchanged.
 *
 * Usage
 * - Template: `{{ value | phone }}`
 */
@Pipe({
  name: 'phone',
  standalone: true
})
export class PhonePipe implements PipeTransform {
  transform(value?: string | null): string {
    const raw = (value ?? '').toString().trim();
    if (!raw) return '';

    let digitsOnly = raw.replaceAll(/\D/g, '');
    if (digitsOnly.length === 11 && digitsOnly.startsWith('1')) {
      digitsOnly = digitsOnly.slice(1);
    }

    if (digitsOnly.length !== 10) return raw;

    const area = digitsOnly.slice(0, 3);
    const prefix = digitsOnly.slice(3, 6);
    const line = digitsOnly.slice(6);
    return `(${area}) ${prefix}-${line}`;
  }
}
